import { endpoints } from 'api/endpoints'
import { GetArrayResponse } from 'interfaces/api.interfaces'
import { PythonType } from 'interfaces/api/pythonTypes.interfaces'
import { axios } from 'modules/axios'

const getAll = async (): GetArrayResponse<PythonType> => {
  const { data: response } = await axios.request<PythonType[]>({
    method: 'GET',
    url: endpoints.pythonTypes.getAll(),
  })
  return response
}

export const pythonTypesApi = {
  getAll,
}
